import { ILiveVideoVo } from '@/schemas/doctor';

interface State {
  downloadModalVisible: boolean;
  downloadConfirmModalVisible: boolean;
  confirmModalVisible: boolean;
  downloadSuccessModalVisible: boolean;
  downloadFailModalVisible: boolean;
  downloadProgressModalVisible: boolean;
  downloadCancelModalVisible: boolean;
  downloadProgress: number;
  downloadVideo: {
    materialLink: string;
    title: string;
    videoTimeDesc: string;
    userName: string;
    coverUrl: string;
    materialSize: number;
  };
}

const initState: State = {
  downloadModalVisible: false,
  downloadConfirmModalVisible: false,
  confirmModalVisible: false,
  downloadSuccessModalVisible: false,
  downloadFailModalVisible: false,
  downloadProgressModalVisible: false,
  downloadCancelModalVisible: false,
  downloadProgress: 0,
  downloadVideo: {
    materialLink: '',
    title: '',
    videoTimeDesc: '',
    userName: '',
    coverUrl: '',
    materialSize: 0
  }
};

const workstation = {
  state: initState,

  reducers: {
    setDownloadModalVisible(state: State, payload: boolean) {
      return {
        ...state,
        downloadModalVisible: payload
      };
    },
    setDownloadConfirmModalVisible(state: State, payload: boolean) {
      return {
        ...state,
        downloadConfirmModalVisible: payload
      };
    },
    setConfirmModalVisible(state: State, payload: boolean) {
      return {
        ...state,
        confirmModalVisible: payload
      };
    },
    setDownloadSuccessModalVisible(state: State, payload: boolean) {
      return {
        ...state,
        downloadSuccessModalVisible: payload
      };
    },
    setDownloadFailModalVisible(state: State, payload: boolean) {
      return {
        ...state,
        downloadFailModalVisible: payload
      };
    },
    setDownloadProgressModalVisible(state: State, payload: boolean) {
      return {
        ...state,
        downloadProgressModalVisible: payload
      };
    },
    setDownloadCancelModalVisible(state: State, payload: boolean) {
      return {
        ...state,
        downloadCancelModalVisible: payload
      };
    },
    setDownloadProgress(state: State, payload: number) {
      return {
        ...state,
        downloadProgress: payload
      };
    },
    setDownloadVideo(state: State, payload: ILiveVideoVo) {
      return {
        ...state,
        downloadVideo: {
          ...payload
        }
      };
    }
  }
};

export default workstation;
